<!-- @format -->
<template>
    <div class="autotask-export-company-widget">
        <autotask-export-widget-strategy-step
            v-show="currentStep === 'strategy'"
            :companyId="companyId"
            :exportMethod="exportMethod"
            :companySelected="companySelected"
            :contacts="contacts"
            @exportMethod:update="updateExportMethod($event)"
            @companySelected:update="updateCompanySelected($event)"
            @contacts:update="updateContacts($event)"
            @nextStep="finishStrategyStep($event)"
            @closeWidget="closeWidget($event)"
        />
        <autotask-export-widget-company-step
            v-show="currentStep === 'exportCompany'"
            ref="companyStep"
            :companyId="companyId"
            :exportMethod="exportMethod"
            @previousStep="goToStep('strategy')"
            @nextStep="finishCompanyExportStep()"
            @closeWidget="closeWidget($event)"
        />
        <autotask-export-widget-contacts-step
            v-show="currentStep === 'exportContacts'"
            :url="companyInfo.webUrl"
            :selectedContacts="selectedContacts"
            @nextStep="finishExport()"
            @closeWidget="closeWidget($event)"
        />
    </div>
</template>

<script>
const AutotaskExportWidgetStrategyStep = () =>
    import(
        '@/components/sliding-widgets/autotask-export-widget/autotask-export-widget-strategy-step'
    );
const AutotaskExportWidgetCompanyStep = () =>
    import(
        '@/components/sliding-widgets/autotask-export-widget/autotask-export-widget-company-step'
    );
const AutotaskExportWidgetContactsStep = () =>
    import(
        '@/components/sliding-widgets/autotask-export-widget/autotask-export-widget-contacts-step'
    );

import EventBus from '@/scripts/event-bus.js';

export default {
    name: 'AutotaskExportCompanyWidget',

    components: {
        'autotask-export-widget-strategy-step': AutotaskExportWidgetStrategyStep,
        'autotask-export-widget-company-step': AutotaskExportWidgetCompanyStep,
        'autotask-export-widget-contacts-step': AutotaskExportWidgetContactsStep,
    },

    props: {
        widget: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            companyId: this.widget.id,
            currentStep: 'strategy',
            exportMethod: null,
            companySelected: true,
            contacts: [],
            companyInfo: {
                webUrl: ''
            },
        };
    },

    computed: {
        selectedContacts() {
            return this.contacts.filter((contact) => contact.selected);
        },
    },

    methods: {
        updateExportMethod(exportMethod) {
            this.exportMethod = exportMethod;
        },

        updateCompanySelected(companySelected) {
            this.companySelected = companySelected;
        },

        updateContacts(contacts) {
            this.contacts = [...contacts];
        },

        finishStrategyStep(companyInfo) {
            this.companyInfo = companyInfo;
            if (this.companySelected) {
                this.goToStep('exportCompany');
                this.$refs.companyStep.exportCompany(this.companyInfo);
            } else if (this.selectedContacts.length > 0) {
                this.goToStep('exportContacts');
            }
        },

        finishCompanyExportStep() {
            if (this.selectedContacts.length > 0) {
                this.goToStep('exportContacts');
            } else {
                this.finishExport();
            }
        },

        closeWidget() {
            EventBus.$emit('close-widget', this.widget);
        },

        goToStep(step) {
            this.currentStep = step;
        },

        finishExport() {
            EventBus.$emit('company:update');

            this.closeWidget();
        },
    },
};
</script>

<style>
.autotask-export-company-widget .action-container .back-btn {
    width: 128px;
    background: transparent;
    color: #18aeff;
    margin-right: 10px;
}

.autotask-export-company-widget .action-container .back-btn:hover {
    background: #e1e0e5;
}

.autotask-export-company-widget .cancel-btn {
    background: transparent;
    color: #877d88;
    border: none;
}

.autotask-export-company-widget .cancel-btn:hover {
    background: #e9e9ef;
}

.autotask-export-company-widget .action-container {
    display: flex;
}

.autotask-export-company-widget .loading {
    text-align: center;
}
</style>
